// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"04c3be85","138":"0872fa3f","897":"d735812c"}[chunkId] + ".chunk.css";
};